<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-toolbar flat class="toolbar" dense justify="center">
                <v-toolbar-title align="center">
                    <strong> Organization Fees Collection Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0f2027" rounded dense required v-model="org" :items="org_list" item-text="name" return-object label="Organization" outlined @click="clear()" @change="getAy()"></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0f2027" rounded dense required v-model="std" :items="standard_list" item-text="standard" item-value="standard" label="Standard" @click="clear()" outlined></v-autocomplete>
                </v-col>
                <v-col sm="2" v-if="std">
                    <v-btn rounded class="button mt-6" @click="getAllReport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="org_data_list != '' && org.name == 'All'">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Organization Fees Collection Report </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <br />
                <center><chart auto-resize :options="option1"></chart></center>
                <v-data-table :headers="headers" dense :items="org_data_list" class="elevation-1 mytable">
                    <template v-slot:item.view="{ item }">
                        <v-btn class="btn-css btn" @click="getDetailedReport(item.org_id)"><v-icon class="mr-2 v-icon-size" color="#0f2027">mdi-eye</v-icon></v-btn>
                    </template>
                </v-data-table>
            </v-col>
            <v-dialog v-model="dialog" fullscreen>
                <v-card>
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Organiztion Fees Collection Report</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-btn class="toolbar" @click="dialog = false">Cancel</v-btn>
                    </v-toolbar>
                    <v-col cols="12" sm="12" md="12" v-if="org_data != ''">
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <v-toolbar class="toolbar" flat dense>
                                    <v-toolbar-title>
                                        <strong> RTE Quota Fees Collection Report </strong>
                                    </v-toolbar-title>
                                </v-toolbar>
                                <br />
                                <!-- new code  -->
                                <v-row dense>
                                    <v-col cols="12" sm="4" md="4">
                                        <span> <v-icon class="dot" style="background-color: #c23531;" color="#c23531">mdi-radiobox-blank </v-icon>Paid Amount</span>
                                    </v-col>

                                    <v-col cols="12" sm="4" md="4">
                                        <span> <v-icon class="dot" style="background-color: #2f4554;" color="#2f4554">mdi-radiobox-blank </v-icon>Remaining Amount</span>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <span> <v-icon class="dot" style="background-color: #61a0a8;" color="#61a0a8">mdi-radiobox-blank </v-icon>Total Amount</span>
                                    </v-col>
                                </v-row>
                                <!-- new code end -->
                                <br />
                                <center><chart auto-resize :options="option2"></chart></center>
                                <br />
                                <v-simple-table dense class="elevation-1 mytable" fixed-header height="500px">
                                    <thead>
                                        <tr class="">
                                            <th class="">Sr. No.</th>
                                            <th class="">Standard</th>
                                            <th class="" colspan="3">
                                                <center>RTE</center>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody style="overflow-y: scroll;">
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th v-for="(header, index) in comp_header" :key="index">
                                                {{ header }}
                                            </th>
                                        </tr>
                                        <tr v-for="(s, index) in org_data" :key="s.std_id">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ s.std_name }}</td>
                                            <td v-for="(header, index) in s.rte_fee" :key="index">
                                                {{ header }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-toolbar class="toolbar" flat dense>
                                    <v-toolbar-title>
                                        <strong> General Quota Fees Collection Report </strong>
                                    </v-toolbar-title>
                                </v-toolbar>
                                <br />
                                <!-- new code  -->
                                <v-row dense>
                                    <v-col cols="12" sm="4" md="4">
                                        <span> <v-icon class="dot" style="background-color: #c23531;" color="#c23531">mdi-radiobox-blank </v-icon>Paid Amount</span>
                                    </v-col>

                                    <v-col cols="12" sm="4" md="4">
                                        <span> <v-icon class="dot" style="background-color: #2f4554;" color="#2f4554">mdi-radiobox-blank </v-icon>Remaining Amount</span>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <span> <v-icon class="dot" style="background-color: #61a0a8;" color="#61a0a8">mdi-radiobox-blank </v-icon>Total Amount</span>
                                    </v-col>
                                </v-row>
                                <!-- new code end -->
                                <br />
                                <center><chart auto-resize :options="option3"></chart></center>
                                <br />
                                <v-simple-table dense class="elevation-1 mytable" fixed-header height="500px">
                                    <thead>
                                        <tr class="">
                                            <th class="">Sr. No.</th>
                                            <th class="">Standard</th>
                                            <th class="" colspan="3">
                                                <center>General</center>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody style="overflow-y: scroll;">
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th v-for="(header, index) in comp_header" :key="index">
                                                {{ header }}
                                            </th>
                                        </tr>
                                        <tr v-for="(s, index) in org_data" :key="s.std_id">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ s.std_name }}</td>
                                            <td v-for="(header, index) in s.general_fee" :key="index">
                                                {{ header }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-row justify="center" dense>
                        <v-btn class="button mt-3" @click="dialog = false">Cancel</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                loader: false,
                overlay: false,
                color: "",
                snackbar: false,
                search: null,
                snackbar_msg: null,
                fees_structure_data: null,
                std: null,
                header: null,
                standard_list: null,
                org_list: null,
                display_data: false,
                org: "",
                ay: null,
                org_data_list: [],
                org_data: [],
                fetch_loader: false,
                comp_header: [],
                dialog: false,
                headers: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Organization",
                        align: "center",
                        sortable: false,
                        value: "org_name",
                    },
                    {
                        text: "Paid Amount",
                        align: "center",
                        sortable: false,
                        value: "total_paid",
                    },
                    {
                        text: "Remaining Amount",
                        align: "center",
                        sortable: false,
                        value: "total_remaining",
                    },
                    {
                        text: "Total Amount",
                        align: "center",
                        sortable: false,
                        value: "total_amount",
                    },
                    {
                        text: "Detailed Report",
                        align: "center",
                        sortable: false,
                        value: "view",
                    },
                ],
                option1: {
                    height: "200px",
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "shadow",
                            label: {
                                show: true,
                            },
                        },
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            mark: { show: true },
                            magicType: {
                                show: true,
                                type: ["line", "bar", "stack"],
                                title: {
                                    line: "Switch to Line Chart",
                                    bar: "Switch to Bar Chart",
                                    stack: "Switch to Stack Chart",
                                },
                            },
                            restore: { show: true, title: "Restore" },
                            saveAsImage: {
                                show: true,
                                title: "Save As Image",
                            },
                            dataView: {
                                show: true,
                                title: "Data View",
                                readonly: false,
                            },
                        },
                    },
                    calculable: true,
                    legend: {
                        data: [],
                        itemGap: 5,
                    },
                    grid: {
                        top: "12%",
                        left: "5%",
                        right: "10%",
                        containLabel: true,
                    },
                    xAxis: {
                        type: "category",
                        data: [],
                        axisLabel: {
                            margin: 15,
                            rotate: 45,
                        },
                        name: "School",
                        nameLocation: "end",
                        offset: 10,
                    },
                    yAxis: {
                        type: "value",
                        name: "Fees Collection",
                        nameLocation: "end",
                        offset: 10,
                    },
                    // dataZoom: [
                    //     {
                    //         show: true,
                    //         start: 94,
                    //         end: 100,
                    //     },
                    //     {
                    //         type: "inside",
                    //         start: 94,
                    //         end: 100,
                    //     },
                    //     {
                    //         show: true,
                    //         yAxisIndex: 0,
                    //         filterMode: "empty",
                    //         width: 30,
                    //         height: "80%",
                    //         showDataShadow: false,
                    //         left: "93%",
                    //     },
                    // ],
                    series: [
                        {
                            data: [],
                            value: [],
                            type: "bar",
                            // label: {
                            //     show: true,
                            //     position: "top",
                            //     rotate: 45,
                            //     offset: [2, 5],
                            // },
                            //name:'Direct'
                        },
                        {
                            data: [],
                            value: [],
                            type: "bar",
                            // label: {
                            //     show: true,
                            //     rotate: 45,
                            //     position: "top",
                            //     offset: [2, 5],
                            // },
                            //name:'Direct'
                        },
                        {
                            data: [],
                            value: [],
                            type: "bar",
                            // label: {
                            //     show: true,
                            //     rotate: 45,
                            //     position: "top",
                            //     offset: [2, 5],
                            // },
                            //name:'Direct'
                        },
                    ],
                },

                option2: {
                    height: "200px",
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "shadow",
                            label: {
                                show: true,
                            },
                        },
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            mark: { show: true },
                            magicType: {
                                show: true,
                                type: ["line", "bar", "stack"],
                                title: {
                                    line: "Switch to Line Chart",
                                    bar: "Switch to Bar Chart",
                                    stack: "Switch to Stack Chart",
                                },
                            },
                            restore: { show: true, title: "Restore" },
                            saveAsImage: {
                                show: true,
                                title: "Save As Image",
                            },
                            dataView: {
                                show: true,
                                title: "Data View",
                                readonly: false,
                            },
                        },
                    },
                    calculable: true,
                    legend: {
                        data: [],
                        itemGap: 5,
                    },
                    grid: {
                        top: "12%",
                        left: "5%",
                        right: "10%",
                        containLabel: true,
                    },
                    xAxis: {
                        type: "category",
                        data: [],
                        axisLabel: {
                            margin: 15,
                            rotate: 45,
                        },
                        name: "RTE",
                        nameLocation: "end",
                        offset: 10,
                    },
                    yAxis: {
                        type: "value",
                        name: "Fees Collection",
                        nameLocation: "end",
                        offset: 10,
                    },
                    // dataZoom: [
                    //     {
                    //         show: true,
                    //         start: 94,
                    //         end: 100,
                    //     },
                    //     {
                    //         type: "inside",
                    //         start: 94,
                    //         end: 100,
                    //     },
                    //     {
                    //         show: true,
                    //         yAxisIndex: 0,
                    //         filterMode: "empty",
                    //         width: 30,
                    //         height: "80%",
                    //         showDataShadow: false,
                    //         left: "93%",
                    //     },
                    // ],
                    series: [
                        {
                            data: [],
                            value: [],
                            type: "bar",
                            // label: {
                            //     show: true,
                            //     position: "top",
                            //     rotate: 45,
                            //     offset: [2, 5],
                            // },
                            //name:'Direct'
                        },
                        {
                            data: [],
                            value: [],
                            type: "bar",
                            // label: {
                            //     show: true,
                            //     rotate: 45,
                            //     position: "top",
                            //     offset: [2, 5],
                            // },
                            //name:'Direct'
                        },
                        {
                            data: [],
                            value: [],
                            type: "bar",
                            // label: {
                            //     show: true,
                            //     rotate: 45,
                            //     position: "top",
                            //     offset: [2, 5],
                            // },
                            //name:'Direct'
                        },
                    ],
                },

                option3: {
                    height: "200px",
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "shadow",
                            label: {
                                show: true,
                            },
                        },
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            mark: { show: true },
                            magicType: {
                                show: true,
                                type: ["line", "bar", "stack"],
                                title: {
                                    line: "Switch to Line Chart",
                                    bar: "Switch to Bar Chart",
                                    stack: "Switch to Stack Chart",
                                },
                            },
                            restore: { show: true, title: "Restore" },
                            saveAsImage: {
                                show: true,
                                title: "Save As Image",
                            },
                            dataView: {
                                show: true,
                                title: "Data View",
                                readonly: false,
                            },
                        },
                    },
                    calculable: true,
                    legend: {
                        data: [],
                        itemGap: 5,
                    },
                    grid: {
                        top: "12%",
                        left: "5%",
                        right: "10%",
                        containLabel: true,
                    },
                    xAxis: {
                        type: "category",
                        data: [],
                        axisLabel: {
                            margin: 15,
                            rotate: 45,
                        },
                        name: "General",
                        nameLocation: "end",
                        offset: 10,
                    },
                    yAxis: {
                        type: "value",
                        name: "Fees Collection",
                        nameLocation: "end",
                        offset: 10,
                    },
                    // dataZoom: [
                    //     {
                    //         show: true,
                    //         start: 94,
                    //         end: 100,
                    //     },
                    //     {
                    //         type: "inside",
                    //         start: 94,
                    //         end: 100,
                    //     },
                    //     {
                    //         show: true,
                    //         yAxisIndex: 0,
                    //         filterMode: "empty",
                    //         width: 30,
                    //         height: "80%",
                    //         showDataShadow: false,
                    //         left: "93%",
                    //     },
                    // ],
                    series: [
                        {
                            data: [],
                            value: [],
                            type: "bar",
                            // label: {
                            //     show: true,
                            //     position: "top",
                            //     rotate: 45,
                            //     offset: [2, 5],
                            // },
                            //name:'Direct'
                        },
                        {
                            data: [],
                            value: [],
                            type: "bar",
                            // label: {
                            //     show: true,
                            //     rotate: 45,
                            //     position: "top",
                            //     offset: [2, 5],
                            // },
                            //name:'Direct'
                        },
                        {
                            data: [],
                            value: [],
                            type: "bar",
                            // label: {
                            //     show: true,
                            //     rotate: 45,
                            //     position: "top",
                            //     offset: [2, 5],
                            // },
                            //name:'Direct'
                        },
                    ],
                },
            };
        },
        methods: {
            clear() {
                this.org_data_list = [];
                this.org_data = [];
            },
            getAllReport() {
                if (this.org.name == "All") {
                    this.fetch_loader = true;
                    const data = {
                        std: this.std,
                        org: this.org.id,
                    };
                    axios
                        .post("/Management/getPaymentDailyTransactionReport", data)
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.org_data_list = res.data.org_data_list;
                                this.option1.series[0].data = res.data.value2;
                                this.option1.series[1].data = res.data.value3;
                                this.option1.series[2].data = res.data.value;
                                this.option1.xAxis.data = res.data.data;
                                this.option1.legend.data = res.data.header_list;
                                console.log(this.option1.legend.data);
                                this.fetch_loader = false;
                            } else {
                                this.showSnackbar("#b71c1c", "Something went wrong!");
                                this.fetch_loader = false;
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                            this.fetch_loader = false;
                        })
                        .finally(() => {
                            //close loader
                            this.fetch_loader = false;
                        });
                } else {
                    // alert("in else")
                    this.getDetailedReport(this.org.id);
                }
            },
            getDetailedReport(org) {
                this.overlay = true;
                const data = {
                    std: this.std,
                    org: org,
                };
                axios
                    .post("/Management/getDetailedReport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.org_data = res.data.org_data;
                            this.comp_header = res.data.comp_header;

                            this.option2.series[0].data = res.data.value2;
                            this.option2.series[1].data = res.data.value3;
                            this.option2.series[2].data = res.data.value;
                            this.option2.xAxis.data = res.data.data;

                            this.option3.series[0].data = res.data.value2_general;
                            this.option3.series[1].data = res.data.value3_general;
                            this.option3.series[2].data = res.data.value_general;
                            this.option3.xAxis.data = res.data.data;

                            this.fetch_loader = false;
                            this.dialog = true;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        //close loader
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/Management/getOrg")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.org_list = res.data.org_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            getAy() {
                (this.academic_year_list = null), (this.standard_list = null), (this.ay = null);
                this.std = null;
                const data = {
                    org: this.org.id,
                };
                axios
                    .post("/Management/getAy", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.academic_year_list = res.data.academic_year_list;
                            this.standard_list = res.data.standard_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: center;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    /* shiv css */
    .dot {
        height: 25px;
        width: 25px;
        /* background-color: #bbb; */
        border-radius: 50%;
        display: inline-block;
    }
</style>
